import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { DeliveryDiscountEntity } from '../../domain/entities/DeliveryDiscountEntity'
import type { DeliveryDiscountAdminDto } from '@/backend/market'

export class DeliveryDiscountModel extends DeliveryDiscountEntity {
  constructor(dataDto: DeliveryDiscountAdminDto) {
    super()
    mapEntityProperties<DeliveryDiscountEntity>(this, dataDto, {
      map: {
        segments: dataDto.segments?.map((segment) => ({
          ...segment,
          shareType: segment.limitedBranchShareAmount ? 'Amount' : 'Ratio'
        }))
      }
    })
  }
}
